import React from "react";
import { assets } from "../assests/assests";
import drone1Img from "../assests/drone1_custom.png";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

function About({ islogin }) {
  return (
    <div className="py-24 bg-white text-gray-900 relative overflow-hidden border-b border-gray-200 font-sans">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          
          {/* LEFT COLUMN: Clean Luxury Typography (No "About Us" pill badge!) */}
          <div className="lg:col-span-6 flex flex-col justify-between z-20">
            
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, ease: "easeOut" }}
              className="text-4xl sm:text-5xl lg:text-6xl font-black text-gray-950 tracking-tight leading-[1.15] mb-8 font-sans"
            >
              NXV DYNAMICS: Innovate. Engineer. Empower.
            </motion.h2>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, ease: "easeOut", delay: 0.2 }}
              className="text-lg sm:text-xl text-gray-600 font-normal leading-relaxed mb-10 max-w-2xl"
            >
              We bridge the gap between advanced Agricultural Technology and cutting-edge software engineering. From smart soil testing devices, autonomous LiDAR rovers, and multi-spectral drone monitoring to custom web & app development, embedded AI engines, and instant telemetry synchronization—we deliver complete, end-to-end technological autonomy.
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, ease: "easeOut", delay: 0.4 }}
            >
              <Link 
                to="/about" 
                className="group inline-flex items-center gap-3 px-8 py-4 bg-gray-950 text-white font-bold text-sm rounded-full shadow-[0_10px_25px_rgba(0,0,0,0.15)] hover:bg-black hover:scale-105 transition-all duration-300"
              >
                <span>Discover Our Engineering</span>
                <span className="group-hover:translate-x-1 transition-transform">&rarr;</span>
              </Link>
            </motion.div>

          </div>


          {/* RIGHT COLUMN: Modern Bento Photo Grid (Showcasing Custom Drone & Precision Ag) */}
          <div className="lg:col-span-6">
            <div className="grid grid-cols-2 gap-4 sm:gap-6">
              
              {/* Bento Card 1: Custom Background-Free Drone Floating */}
              <motion.div 
                whileHover={{ y: -5, scale: 1.02 }}
                transition={{ duration: 0.3 }}
                className="bg-gray-100 rounded-3xl p-6 border border-gray-200/80 shadow-md flex items-center justify-center min-h-[180px] sm:min-h-[220px] relative overflow-hidden group"
              >
                <div className="absolute inset-0 bg-[radial-gradient(#cbd5e1_1px,transparent_1px)] [background-size:16px_16px] opacity-40"></div>
                <img 
                  src={drone1Img} 
                  alt="Autonomous Drone" 
                  className="max-h-[140px] sm:max-h-[180px] w-auto object-contain relative z-10 drop-shadow-xl group-hover:scale-105 transition-transform duration-500" 
                />
              </motion.div>

              {/* Bento Card 2: Precision Ag Tech */}
              <motion.div 
                whileHover={{ y: -5, scale: 1.02 }}
                transition={{ duration: 0.3 }}
                className="rounded-3xl overflow-hidden border border-gray-200/80 shadow-md min-h-[180px] sm:min-h-[220px] bg-gray-50"
              >
                <img 
                  src={assets.about2} 
                  alt="Smart Farming Technology" 
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" 
                />
              </motion.div>

              {/* Bento Card 3: Soil Testing & AI Guiding */}
              <motion.div 
                whileHover={{ y: -5, scale: 1.02 }}
                transition={{ duration: 0.3 }}
                className="rounded-3xl overflow-hidden border border-gray-200/80 shadow-md min-h-[180px] sm:min-h-[220px] bg-gray-50"
              >
                <img 
                  src={assets.about3} 
                  alt="Agricultural AI Analytics" 
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" 
                />
              </motion.div>

              {/* Bento Card 4: Field Telemetry */}
              <motion.div 
                whileHover={{ y: -5, scale: 1.02 }}
                transition={{ duration: 0.3 }}
                className="rounded-3xl overflow-hidden border border-gray-200/80 shadow-md min-h-[180px] sm:min-h-[220px] bg-gray-50"
              >
                <img 
                  src={assets.about4} 
                  alt="Field Telemetry Operations" 
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" 
                />
              </motion.div>

            </div>
          </div>

        </div>

      </div>
    </div>
  );
}

export default About;
